import { render, staticRenderFns } from "./EstadisticasEmailsComunicados.vue?vue&type=template&id=8901f4b0"
import script from "./EstadisticasEmailsComunicados.vue?vue&type=script&lang=js"
export * from "./EstadisticasEmailsComunicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports